import React from 'react';

import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

const TeacherCreate = (props) => {
  return (
    <Create {...props} title="Create teacher">
      <SimpleForm>
        <TextInput disabled source="id" />
        <TextInput source="first_name" />
        <TextInput source="last_name" />
        <TextInput source="email" />
        <TextInput source="mobile" />
        <ReferenceInput source="class_id" reference="classes">
          <SelectInput
            label="Class"
            source="class_id"
            optionText="class_code"
          />
        </ReferenceInput>
        <SelectInput
          source="role"
          choices={[
            { id: 'teacher', name: 'Teacher' },
            { id: 'trainer', name: 'Trainer' },
            { id: 'principal', name: 'Principal' },
            { id: 'admin', name: 'Admin' },
          ]}
          emptyText="Unknown"
          emptyValue="unknown"
        />
      </SimpleForm>
    </Create>
  );
};

export default TeacherCreate;
